<template>
  <v-app>
    <v-main>
      <div class="register-page">
        <div class="sidebar register-page-sidebar">
          <img src="/image/logo-white.png" alt="" class="register-page-img py-0 px-16">
        </div>
        <slot></slot>
      </div>
    </v-main>

  </v-app>

</template>

<script>
export default {
  name: "LayoutRegister",

}
</script>

<style scoped>
.register-page-sidebar{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh !important;
}

.register-page-img {
  max-width: 100%;   /* never overflow container */
  height: 90%;      /* keep aspect ratio */
  object-fit: contain;
}

@media (max-width: 1200px) {
  .register-page-sidebar{
    display: none;
  }
}

</style>
